import { Container, Header, Heading, Icon, Img, StepList, TextAndMedia } from '@boltenergy-be/design-system'
import { useTranslation } from 'next-i18next/pages'
import styles from './ComplainConfirmation.module.scss'
import { PhoneAvailability } from 'components/phone-availibility/PhoneAvailability'
import Link from 'components/link/Link'
import { BOLT_EMAIL, BOLT_PHONE } from 'constants/constants'
import { I18nUSP } from 'types/i18n'
import { useEffect } from 'react'
import { useGetLanguage } from 'hooks/useGetLanguage'

const ComplaintConfirmation = () => {
  // i18n
  const { t } = useTranslation('complaint', { keyPrefix: 'confirmation' })
  const language = useGetLanguage()

  // Constants
  const email = BOLT_EMAIL[language]

  // Scroll to top upon landing on this page
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <main>
      <Header title={t('header.title')} color="light" classnames={{ container: styles.header }}>
        <p>{t('header.description')}</p>
      </Header>

      <TextAndMedia
        title={t('nextSteps.title')}
        media={{ type: 'image', props: { publicId: 'website/complaint/confirmation-hat', alt: '', fill: true } }}
      >
        <StepList size="large">
          {(t('nextSteps.bullets', { returnObjects: true }) as Omit<I18nUSP, 'key'>[]).map(({ title, description }, index) => (
            <li key={`next-step-${index}`}>
              <div className="flex-col gap-100">
                <Heading as="h2" variant="h4" serif>
                  {title}
                </Heading>
                <p className="text-xl">{description}</p>
              </div>
            </li>
          ))}
        </StepList>
      </TextAndMedia>

      <Container as="section" inset color="dark" classnames={{ content: styles['contact-content'] }}>
        <div className={styles.info}>
          <Heading as="h2" serif>
            {t('contact.title')}
            <br /> <PhoneAvailability />
          </Heading>

          <address className={styles['contact-info']}>
            <div>
              <Icon name="envelope" />
              <Link as="a" href={`mailto:${email}`} variant="inline">
                {email}
              </Link>
            </div>

            <div>
              <Icon name="smartPhone" />
              <Link as="a" href={`tel:${BOLT_PHONE}`} variant="inline">
                {BOLT_PHONE}
              </Link>
            </div>
          </address>
        </div>

        <Img publicId="website/common/customer-care-bolt" fill className={styles.team} alt="" />
      </Container>
    </main>
  )
}

export default ComplaintConfirmation
